module.exports = __webpack_public_path__ + "src/img/zalando/feature-small.e8eb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/feature-small.jpg
// module id = 120
// module chunks = 0